import { useSlider } from '@spa/shared/hooks/slider';

const MIN_NAME = 'min';
const MAX_NAME = 'max';

export const useRange = (ref, min, max, values = [], onChange, step = 1) => {
  if (values.length < 2) {
    throw new Error('must have 2 values');
  }

  const onChangeBoth = (isDragging, name, value) => {
    const oppositeValue = name === MIN_NAME ? maxSlider.value : minSlider.value;

    onChange(
      isDragging,
      [value, oppositeValue].sort((a, b) => a - b)
    );
  };

  const minSlider = useSlider(ref, MIN_NAME, min, max, values[0], onChangeBoth, step);
  const maxSlider = useSlider(ref, MAX_NAME, min, max, values[1], onChangeBoth, step);

  return {
    first: minSlider,
    second: maxSlider,
    minFactor: Math.min(maxSlider.factor, minSlider.factor),
    maxFactor: Math.max(minSlider.factor, maxSlider.factor)
  };
};
